@if ((progress$ | async) === 0) {
  <img src="/assets/designer/schoolLogoPlaceholderUpload.svg" />
  <input
    type="file"
    (change)="filePicked($event)"
    accept="image/jpeg,image/png"
    />
  } @else {
    <mat-progress-spinner
      diameter="150"
      mode="indeterminate"
    ></mat-progress-spinner>
  }
